<div class="filter-container">
  <span>{{'historical.shared_by' | translate}}</span>
  <mat-form-field>
    <mat-select [formControl]="userFilter" (selectionChange)="filterByUser($event)">
      @for (item of usersShared(); track $index) {
        <mat-option [value]="item.id">{{item.first_name + ' ' + item.last_name}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>